import {
  AppBar,
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Slide,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { TransitionProps } from "@mui/material/transitions";
import React, { useEffect, useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { useDispatch } from "react-redux";
import { postDetails, postFeedback } from "../../store/thunks/config.thunk";
import { useTheme } from "@emotion/react";
import { useAutoResponsiveViewportSwitchForModal } from "../../hooks/useAutoResponsiveViewportSwitchForModal";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ComingSoonModal({
  currentContent,
  open,
  setOpen,
}: any) {
  // ya naughty boi!

  useAutoResponsiveViewportSwitchForModal(open);

  const [role, setRole] = useState<string>("");

  const matches = useMediaQuery("(min-width:800px)");
  const dispatch = useDispatch();

  const [value, setValue] = useState<string>("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };
  const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  return (
    <Dialog
      fullScreen={isMobileDevice}
      fullWidth={true}
      maxWidth="sm"
      open={open}
      onClose={() => setOpen(false)}
      // TransitionComponent={Transition}
      style={{ borderRadius: "0px", cursor: "auto" }}
    >
      <DialogContent sx={{ padding: "35px", position: "relative" }}>
        {isMobileDevice ? (
          <IconButton
            edge="start"
            color="primary"
            onClick={() => setOpen(false)}
            aria-label="close"
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "#dbd8d85e",
              zIndex: 10,
              height: "35px",
              width: "35px",
            }}
          >
            <CloseRoundedIcon sx={{}} />
          </IconButton>
        ) : (
          <IconButton
            edge="start"
            color="primary"
            onClick={() => setOpen(false)}
            aria-label="close"
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "#dbd8d85e",
              zIndex: 10,
            }}
          >
            <CloseRoundedIcon />
          </IconButton>
        )}

        {/* {currentContent && ( */}
        <Grid
          container
          xs={12}
          justifyContent={"space-evenly"}
          spacing={matches ? 3 : 1}
          style={{ paddingTop: 10 }}
        >
          <Grid
            item
            xs={12}
            container
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Grid item xs={12}>
              <Typography
                variant="h4"
                align="center"
                sx={{ marginBottom: "20px" }}
              >
                Feedback
              </Typography>
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Would this be something you would like for your business unit?
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={value}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes I am interested"
                  />
                  <FormControlLabel
                    value="not sure"
                    control={<Radio />}
                    label="Not Sure"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="No Thanks"
                  />
                </RadioGroup>
              </FormControl>

              <Typography
                variant="subtitle1"
                align="left"
                sx={{ marginTop: "20px" }}
              >
                Other Feedback
              </Typography>

              <TextField
                fullWidth={true}
                sx={{
                  marginTop: "15px",
                  fontColor: "#686565",
                }}
                value={role}
                multiline
                onChange={(e) => {
                  setRole(e.target.value);
                }}
              />
            </Grid>
            {/* {currentContent.link && ( */}
            <Grid
              item
              xs={12}
              container
              alignItems="center"
              justifyContent="center"
              style={{ marginTop: "20px" }}
            >
              <Button
                variant="outlined"
                style={{
                  textTransform: "none",
                }}
                disabled={value === ""}
                onClick={() => {
                  dispatch(
                    postFeedback({ feedback: value, other: role }) as any
                  );
                  setOpen(false);

                  setRole("");
                  setValue("");
                }}
              >
                Submit
              </Button>
            </Grid>
            {/* )} */}
          </Grid>
        </Grid>
        {/* )} */}
      </DialogContent>
    </Dialog>
  );
}
